var _Box;
import React from 'react';
import Box from '@mui/material/Box';

// export type IngramLogoProps = {
//   height?: string;
//   width?: string;
// };
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function IngramLogoWithRX4CLoginHeader() {
  return _Box || (_Box = /*#__PURE__*/_jsx(Box, {
    height: 20,
    width: 242,
    "data-element": "Box",
    "data-component": "IngramLogoWithRX4CLoginHeader",
    "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx",
    children: /*#__PURE__*/_jsxs("svg", {
      height: "20",
      overflow: "visible",
      viewBox: "184 380 242 30",
      width: 242,
      xmlns: "http://www.w3.org/2000/svg",
      "data-element": "svg",
      "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx",
      children: [/*#__PURE__*/_jsxs("g", {
        "data-element": "g",
        "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M301.67,377.17h0.53c0.35,0,0.66-0.05,0.66-0.48c0-0.38-0.35-0.44-0.65-0.44h-0.54V377.17z M301.07,375.79 h1.2c0.77,0,1.19,0.27,1.19,0.95c0,0.55-0.32,0.82-0.84,0.87l0.87,1.41h-0.61l-0.84-1.39h-0.36v1.39h-0.6V375.79z M304.32,377.42 c0-1.33-0.96-2.3-2.15-2.3c-1.19,0-2.15,0.96-2.15,2.3c0,1.33,0.96,2.3,2.15,2.3C303.36,379.71,304.32,378.75,304.32,377.42 M299.32,377.42c0-1.57,1.28-2.85,2.85-2.85c1.57,0,2.85,1.28,2.85,2.85c0,1.57-1.28,2.85-2.85,2.85 C300.6,380.27,299.32,378.99,299.32,377.42",
          fill: "#0077D4",
          "data-element": "path",
          "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
        }), /*#__PURE__*/_jsx("path", {
          d: "M292.78,383.78c0-0.76,0.73-1.07,1.92-1.07c1.16,0,1.92,0.28,1.92,1.07c0,0.98-1.18,1.09-1.93,1.09 C293.51,384.87,292.78,384.56,292.78,383.78 M297.75,383.78c0-1.49-1.14-2.52-3.06-2.52c-1.39,0-3.04,0.69-3.04,2.52 c0,1.76,1.47,2.54,3.04,2.54C296.29,386.33,297.75,385.54,297.75,383.78 M292.79,390.77v-1.06c0-0.66,0.41-0.89,0.75-0.89 c0.37,0,0.76,0.25,0.76,0.89v1.06H292.79z M295.33,390.77v-1.01l2.34-0.91v-1.54l-2.62,1.1c-0.23-0.64-0.86-1.03-1.53-1.03 c-1.1,0-1.78,0.72-1.78,2.14v2.63h5.93v-1.38H295.33z M293.94,393.48c-1.43,0.16-2.29,0.92-2.29,2.4c0,1.78,1.41,2.66,3.05,2.66 c1.62,0,3.05-0.86,3.05-2.62c0-1.37-0.8-2.3-2.16-2.45l-0.09,1.35c0.57,0.08,1.11,0.38,1.11,1.03c0,1.05-1.05,1.14-1.86,1.14 c-0.72,0-2-0.1-2-1.07c0-0.76,0.61-0.99,1.27-0.99L293.94,393.48z M297.67,399.88h-5.93v1.38h5.93V399.88z M297.67,405.84v0.95 l-4.83,1.43v0.03h4.83v1.17h-5.93v-2.17l3.55-1.04l-3.55-1.09v-2.17h5.93v1.38h-4.83v0.03L297.67,405.84z M175.53,409.42h-22.45 c-1.74-6.45-5.42-20.07-5.42-20.07h-0.07v20.07h-9.18v-27.73h15.93c1.68,6.4,5.19,19.55,5.19,19.55h0.07v-19.55h9.2v4.21 c-2.24,2.37-3.6,5.39-3.6,9.19C165.2,400.54,168.26,407.3,175.53,409.42 M284.6,381.69v27.73h-9.62V387.7h-0.14l-5.53,21.72h-8.88 l-5.5-21.72h-0.15v21.72h-16.81l-1.68-5.97h-9.04l-1.68,5.97h-16.07c0,0-0.54-4.09-0.68-5.11c-0.48-3.44-1.51-4.27-3.56-4.27h-2.81 v9.38h-16.46c4.74-1.08,9.02-3.23,11.48-4.71l-3.46-13.11l-9.19,2.42l1.96,7.43c-0.58,0.41-2.49,1.08-3.8,1.08 c-4.39,0-6.48-4.4-6.48-8.19c0-6.1,6.22-8.45,11.69-8.45c1.27,0,2.92,0.11,3.15,0.14l-1.15-4.35h19.15c7.67,0,10.64,3.63,10.64,7.5 c0,5.86-5.58,6.96-6.65,7.14c-0.02,0-0.02,0.16,0,0.17c2.23,0.42,3.87,1.5,4.92,3.39c-0.04-0.06,5.87-16.67,6.4-18.2h14.73 l6.21,17.39h0.08v-17.39h15.84c0,0,3.67,15.18,3.69,15.18c1.2-5.06,3.6-15.18,3.6-15.18H284.6z M123.6,381.69h10.67 c0,0-0.02,18.43-0.02,27.73c-0.06,0-10.59,0.01-10.65,0V381.69z M231.7,387.65l-2.98,9.14h6.15l-3.01-9.14H231.7z M202.47,393.79 h3.17c2.59,0,3.67-1.34,3.67-2.98c0-2.1-1.79-2.92-3.67-2.92c-1.12,0-3.17,0-3.17,0V393.79z",
          fill: "#0077D4",
          "data-element": "path",
          "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
        })]
      }), /*#__PURE__*/_jsxs("g", {
        "data-element": "g",
        "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx",
        children: [/*#__PURE__*/_jsxs("g", {
          "data-element": "g",
          "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx",
          children: [/*#__PURE__*/_jsx("path", {
            d: "M350.69,409.34h-6.06l-6.37-20.21h5.49l3.96,15.03h0.06l3.96-15.03h5.49L350.69,409.34z",
            fill: "#999999",
            "data-element": "path",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
          }), /*#__PURE__*/_jsx("path", {
            d: "M363.15,389.14h5.35l7.56,20.21h-5.49l-1.25-3.62h-7.05l-1.27,3.62h-5.41L363.15,389.14z M363.49,401.82 h4.58l-2.24-7.08h-0.06L363.49,401.82z",
            fill: "#999999",
            "data-element": "path",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
          }), /*#__PURE__*/_jsx("path", {
            d: "M377.84,389.14h5.41l7.02,12.45h0.06v-12.45h4.95v20.21h-5.41l-7.02-12.6h-0.06v12.6h-4.95V389.14z",
            fill: "#999999",
            "data-element": "path",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
          }), /*#__PURE__*/_jsx("path", {
            d: "M414.77,393.66h-6.03v15.68h-5.26v-15.68h-6.03v-4.53h17.32V393.66z",
            fill: "#999999",
            "data-element": "path",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
          }), /*#__PURE__*/_jsx("path", {
            d: "M420.59,389.14h5.35l7.56,20.21h-5.49l-1.25-3.62h-7.05l-1.27,3.62h-5.41L420.59,389.14z M420.93,401.82 h4.58l-2.24-7.08h-0.06L420.93,401.82z",
            fill: "#999999",
            "data-element": "path",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
          }), /*#__PURE__*/_jsx("path", {
            d: "M452.98,409.34h-3.4l-0.31-2.21c-1.39,1.95-3.76,2.63-5.63,2.63c-6.11,0-10.08-4.67-10.08-10.53 c0-5.86,3.96-10.53,10.08-10.53c4.19,0,8.66,2.24,9.14,7.3h-5.26c-0.17-1.73-1.87-2.77-3.99-2.77c-3.4,0-4.7,3-4.7,6 c0,3,1.3,6,4.7,6c2.6,0,4.36-1.22,4.64-3.06h-3.68v-3.91h8.49V409.34z",
            fill: "#999999",
            "data-element": "path",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
          }), /*#__PURE__*/_jsx("path", {
            d: "M456.66,389.14h16.11v4.22h-10.84v3.54h9.91v4.08h-9.91v3.85h11.12v4.53h-16.39V389.14z",
            fill: "#999999",
            "data-element": "path",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
          })]
        }), /*#__PURE__*/_jsxs("g", {
          "data-element": "g",
          "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx",
          children: [/*#__PURE__*/_jsx("g", {
            "data-element": "g",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx",
            children: /*#__PURE__*/_jsx("path", {
              d: "M332.48,381.69h6.67l-4.92,7.35h-6.86L332.48,381.69z",
              fill: "#0077D4",
              "data-element": "path",
              "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
            })
          }), /*#__PURE__*/_jsx("polygon", {
            fill: "#999999",
            points: "339.15,409.38 320.27,381.69 313.6,381.69 322.99,395.6 313.49,409.38 320.35,409.38  326.32,400.54 332.29,409.38 \t\t",
            "data-element": "polygon",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
          })]
        }), /*#__PURE__*/_jsx("g", {
          "data-element": "g",
          "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx",
          children: /*#__PURE__*/_jsx("path", {
            d: "M476.85,386.5h-0.92v2.53h-0.58v-2.53h-0.92v-0.47h2.42V386.5z M479.13,388.16l0.82-2.13h0.84v3.01h-0.55 v-2.35h-0.01l-0.9,2.35h-0.41l-0.9-2.35h-0.01v2.35h-0.55v-3.01h0.85L479.13,388.16z",
            fill: "#999999",
            "data-element": "path",
            "data-source-file": "IngramLogoWithRX4CLoginHeader.tsx"
          })
        })]
      })]
    })
  }));
}